import { __extends } from "tslib";
import { ASObject, axCoerceString } from '@awayfl/avm2';
var Scene = /** @class */ (function (_super) {
    __extends(Scene, _super);
    function Scene(name, labels, offset, numFrames /*int*/) {
        var _this = _super.call(this) || this;
        _this._name = axCoerceString(name);
        // Note: creating Scene objects in ActionScript, while possible, is undocumented and entirely
        // useless. Luckily, that also means that they're not very carefully implemented.
        // Specifically, the `labels` array isn't cloned during construction or when returned from
        // the getter. I.e., it can be modified freely.
        _this._labels = labels;
        _this.offset = offset;
        _this._numFrames = numFrames | 0;
        return _this;
    }
    Object.defineProperty(Scene.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scene.prototype, "labels", {
        get: function () {
            return this._labels;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scene.prototype, "numFrames", {
        get: function () {
            return this._numFrames;
        },
        enumerable: true,
        configurable: true
    });
    Scene.prototype.clone = function () {
        var labels_ = this._labels.value.map(function (label) { return label.clone(); });
        return new Scene(this._name, this.sec.createArrayUnsafe(labels_), this.offset, this._numFrames);
    };
    Scene.prototype.getLabelByName = function (name, ignoreCase) {
        if (ignoreCase) {
            name = name.toLowerCase();
        }
        var labels = this._labels.value;
        for (var i = 0; i < labels.length; i++) {
            var label = labels[i];
            if (ignoreCase ? label.name.toLowerCase() === name : label.name === name) {
                return label;
            }
        }
        return null;
    };
    Scene.prototype.getLabelByFrame = function (frame) {
        var labels = this._labels.value;
        for (var i = 0; i < labels.length; i++) {
            var label = labels[i];
            if (label.frame === frame) {
                return label;
            }
        }
        return null;
    };
    Scene.classInitializer = null;
    Scene.classSymbols = null; // [];
    Scene.instanceSymbols = null;
    return Scene;
}(ASObject));
export { Scene };
